import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "card-body py-4" }
const _hoisted_4 = { class: "d-flex gap-10 justify-content-between" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_6 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "text-center min-w-150px" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = ["onClick"]

import { ref, onMounted, provide } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserService from "../services/UserService";
import UserKycFinalize from "../components/UserKycFinalize.vue";
import UserAuKycFinalize from "../components/UserAuKycFinalize.vue";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";
import { Search } from "@element-plus/icons-vue";
import CommonTabs from "@/projects/tenant/components/CommonTabs.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'KycFinalize',
  setup(__props) {

const { t } = useI18n();
const selectedKYC = ref(false);
const selectedPartyId = ref("-1");
const isLoading = ref(true);
const items = ref(Array<any>());
const isNewAuVerification = ref(false);

const criteria = ref<any>({
  sortField: "updatedOn",
  status: VerificationStatusTypes.AwaitingApprove,
});

const returnTable = () => {
  selectedKYC.value = false;
  isLoading.value = false;
};

onMounted(async () => {
  await fetchData();
});
const search = async () => {
  await fetchData();
};
const fetchData = async (_page?: number) => {
  isLoading.value = true;
  selectedKYC.value = false;
  if (_page) criteria.value.page = _page;
  try {
    const res = await UserService.queryKycForms(criteria.value);
    items.value = res.data;
    res.criteria.statuses = null;
    criteria.value = res.criteria;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};
const reset = () => {
  criteria.value.email = null;
  fetchData();
};
const showUserKycForm = async (_partyId) => {
  const userVerification = await UserService.queryVerifications({
    partyId: _partyId,
  });

  await UserService.getVerificationById(userVerification.data[0].id).then(
    (res) => {
      if (!("bg1" in res.financial)) {
        isNewAuVerification.value = true;
      } else {
        isNewAuVerification.value = false;
      }
      selectedPartyId.value = _partyId;
      selectedKYC.value = true;
    }
  );
};

const tabsData = [
  {
    index: 0,
    label: t("status.pending"),
    status: VerificationStatusTypes.AwaitingApprove,
  },
  {
    index: 1,
    label: t("status.finalized"),
    status: VerificationStatusTypes.Approved,
  },
  {
    index: 2,
    label: t("status.all"),
    status: null,
  },
];

provide("criteria", criteria);
provide("isLoading", isLoading);
provide("tabsData", tabsData);
provide("fetchData", fetchData);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!selectedKYC.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(CommonTabs),
              _createElementVNode("div", null, [
                _createVNode(_component_el_input, {
                  class: "w-400px",
                  modelValue: criteria.value.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.email) = $event)),
                  clearable: true,
                  placeholder: "Email",
                  onKeyup: _withKeys(search, ["enter"]),
                  disabled: isLoading.value
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: _unref(Search),
                      onClick: search,
                      disabled: isLoading.value,
                      loading: isLoading.value
                    }, null, 8, ["icon", "disabled", "loading"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "onKeyup", "disabled"]),
                _createVNode(_component_el_button, {
                  class: "ms-4",
                  type: "info",
                  plain: "",
                  onClick: reset,
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_6, [
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("fields.client")), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("action.action")), 1)
                ])
              ]),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                    _createVNode(_component_LoadingRing)
                  ]))
                : (!isLoading.value && items.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                      _createVNode(_component_NoDataBox)
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_14, [
                            _createVNode(_component_UserInfo, {
                              url: "#",
                              user: item.user,
                              class: "me-2"
                            }, null, 8, ["user"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_TimeShow, {
                              "date-iso-string": item.updatedOn
                            }, null, 8, ["date-iso-string"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_TimeShow, {
                              "date-iso-string": item.createdOn
                            }, null, 8, ["date-iso-string"])
                          ]),
                          _createElementVNode("td", _hoisted_15, [
                            _createElementVNode("button", {
                              class: "btn btn-light btn-primary btn-sm me-3",
                              onClick: ($event: any) => (showUserKycForm(item.partyId))
                            }, _toDisplayString(_ctx.$t("action.view")), 9, _hoisted_16)
                          ])
                        ]))
                      }), 128))
                    ]))
            ]),
            _createVNode(_component_TableFooter, {
              onPageChange: fetchData,
              criteria: criteria.value
            }, null, 8, ["criteria"])
          ])
        ]))
      : (selectedKYC.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (isNewAuVerification.value)
              ? (_openBlock(), _createBlock(UserAuKycFinalize, {
                  key: "au-kyc",
                  selectedPartyId: selectedPartyId.value,
                  viewFinalize: criteria.value.status == _unref(VerificationStatusTypes).Approved,
                  onFetchData: fetchData,
                  onReturnTable: returnTable
                }, null, 8, ["selectedPartyId", "viewFinalize"]))
              : (_openBlock(), _createBlock(UserKycFinalize, {
                  key: "normal-kyc",
                  selectedPartyId: selectedPartyId.value,
                  viewFinalize: criteria.value.status == _unref(VerificationStatusTypes).Approved,
                  onFetchData: fetchData,
                  onReturnTable: returnTable
                }, null, 8, ["selectedPartyId", "viewFinalize"]))
          ], 64))
        : _createCommentVNode("", true)
  ]))
}
}

})